import styled from "styled-components";

const Label = styled.label`
    font-size: ${(props) => props.theme.typography.body.medium.fontSize};
    font-weight: 700;
    padding-bottom: ${(props) => props.theme.spacing.xxs};
`;

export default Label;
